export default __webpack_public_path__ + "static/EviveBrands-3323f2320b16f7460c91f7d1c3973499.png";